// extracted by mini-css-extract-plugin
export default {"container":"AppLoading_container__1Muo7","horizontalContainer":"AppLoading_horizontalContainer__20bGQ","loadingText":"AppLoading_loadingText__fzPU2"};